import { render, staticRenderFns } from "./IconMaxDesconto.vue?vue&type=template&id=012f2fa8"
import script from "./IconMaxDesconto.vue?vue&type=script&lang=js"
export * from "./IconMaxDesconto.vue?vue&type=script&lang=js"
import style0 from "./IconMaxDesconto.vue?vue&type=style&index=0&id=012f2fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports